import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1d365d",
    },
    secondary: {
      main: "#86abd2",
    },
    warning: {
      main: "#ffc107",
    },
    success: {
      main: "#449d48",
    },
    error: {
      main: "#d32f2f",
    },
    info: {
      main: "#1976d2",
    },
  },
});

export default theme;
